<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div v-if="confirmed === null" class="col text-center">
            <p>
              <strong>
                Please wait...
              </strong>
            </p>
          </div>
          <div v-if="confirmed === 1" class="col text-center">
            <p>
              <strong>
                Thank you, your assignment for the move has been confirmed.
              </strong>
            </p>
          </div>
          <div v-if="confirmed === 0" class="col text-center">
            <p>
              <strong>
                Thank you, your assignment for the move has been declined.
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ConfirmJob',
  data: () => ({
    confirmed: null,
  }),
  mounted() {
    this.sendCode();
  },
  methods: {
    sendCode() {
      axios
        .post('movers/confirm', { hash: this.$route.params.token })
        .then(res => {
          this.confirmed = res.data;
        })
        .catch(err => {
          this.confirmed = err;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/movers/ConfirmJob.vue